// import { useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { useNavigate } from "react-router-dom";
// import { loginUser } from "../../redux/features/authSlice";

// export default function Login() {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const { loading, error } = useSelector((state) => state.auth);
//   const [credentials, setCredentials] = useState({
//     username: "",
//     password: "",
//   });

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       const result = await dispatch(loginUser(credentials)).unwrap();

//       // Check if user has admin role
//       if (result.roles.includes("ROLE_ADMIN")) {
//         navigate("/dashboard");
//       } else {
//         // Navigate to appropriate page for non-admin users
//         navigate("/");
//       }
//     } catch (err) {
//       console.error("Login failed:", err);
//     }
//   };

//   return (
//     <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-primary-light to-primary-dark">
//       <div className="max-w-md w-full m-4 space-y-6 p-8 bg-white rounded-2xl shadow-xl">
//         <div className="space-y-4">
//           <h2 className="text-3xl font-bold text-center text-primary">
//             Welcome Back
//           </h2>
//           <p className="text-center text-gray-600">
//             Enter your credentials to access your account
//           </p>
//         </div>

//         <form onSubmit={handleSubmit} className="space-y-6">
//           <div className="space-y-4">
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-1">
//                 User Name
//               </label>
//               <input
//                 type="username"
//                 className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary"
//                 value={credentials.username}
//                 onChange={(e) =>
//                   setCredentials((prev) => ({
//                     ...prev,
//                     username: e.target.value,
//                   }))
//                 }
//               />
//             </div>

//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-1">
//                 Password
//               </label>
//               <input
//                 type="password"
//                 className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary"
//                 value={credentials.password}
//                 onChange={(e) =>
//                   setCredentials((prev) => ({
//                     ...prev,
//                     password: e.target.value,
//                   }))
//                 }
//               />
//             </div>
//           </div>

//           {error && (
//             <div className="p-3 text-sm text-red-600 bg-red-50 rounded-lg">
//               {error}
//             </div>
//           )}

//           <button
//             type="submit"
//             disabled={loading}
//             className="w-full py-3 px-4 bg-primary text-white rounded-lg font-medium
//                        hover:bg-primary-dark focus:outline-none focus:ring-2
//                        focus:ring-offset-2 focus:ring-primary transition-colors
//                        disabled:opacity-50 disabled:cursor-not-allowed"
//           >
//             {loading ? "Signing in..." : "Sign In"}
//           </button>
//         </form>

//         <div className="text-center">
//           <a
//             href="/register"
//             className="text-sm text-primary hover:text-primary-dark"
//           >
//             Don't have an account? Sign up
//           </a>
//         </div>
//       </div>
//     </div>
//   );
// }

import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { loginUser } from "../../redux/features/authSlice";

export default function Login() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { loading, error, accessToken, roles } = useSelector(
    (state) => state.auth
  );

  const [credentials, setCredentials] = useState({
    username: "",
    password: "",
  });

  // Check if user is already logged in
  useEffect(() => {
    if (accessToken && roles.includes("ROLE_ADMIN")) {
      navigate("/dashboard");
    }
  }, [accessToken, roles, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const result = await dispatch(loginUser(credentials)).unwrap();
      if (result.roles.includes("ROLE_ADMIN")) {
        // Replace /admin with /dashboard in the URL
        window.history.replaceState(null, "", "/dashboard");
        navigate("/dashboard", { replace: true });
      } else {
        // Handle non-admin users
        navigate("/");
      }
    } catch (err) {
      console.error("Login failed:", err);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-primary-light to-primary-dark">
      <div className="max-w-md w-full m-4 space-y-6 p-8 bg-white rounded-2xl shadow-xl">
        <div className="space-y-4">
          <h2 className="text-3xl font-bold text-center text-primary">
            Welcome Back
          </h2>
          <p className="text-center text-gray-600">
            Enter your credentials to access your account
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Username
              </label>
              <input
                type="text"
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary"
                value={credentials.username}
                onChange={(e) =>
                  setCredentials((prev) => ({
                    ...prev,
                    username: e.target.value,
                  }))
                }
                required
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Password
              </label>
              <input
                type="password"
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary"
                value={credentials.password}
                onChange={(e) =>
                  setCredentials((prev) => ({
                    ...prev,
                    password: e.target.value,
                  }))
                }
                required
              />
            </div>
          </div>

          {error && (
            <div className="p-3 text-sm text-red-600 bg-red-50 rounded-lg">
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            className="w-full py-3 px-4 bg-primary text-white rounded-lg font-medium 
                     hover:bg-primary-dark focus:outline-none focus:ring-2 
                     focus:ring-offset-2 focus:ring-primary transition-colors
                     disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
